import React, { useState, useEffect } from 'react'
import Pipeline from './components/Pipeline'
import KPIDashboard from './components/KPIDashboard'
import Login from './components/Login'
import { supabase } from './supabaseClient'
import './App.css'

export default function App() {
  const [tab, setTab] = useState('pipeline')
  const [session, setSession] = useState(undefined)

  useEffect(() => {
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session)
    })
    return () => subscription.unsubscribe()
  }, [])

  if (session === undefined) return null

  if (!session) return <Login />

  return (
    <div className="app">
      <aside className="sidebar">
        <div className="sidebar-logo">
          <div className="logo-mark">QT</div>
          <div className="logo-text">
            <span className="logo-name">Quantum</span>
            <span className="logo-sub">Technologies</span>
          </div>
        </div>
        <nav className="sidebar-nav">
          <button className={`nav-item ${tab === 'pipeline' ? 'active' : ''}`} onClick={() => setTab('pipeline')}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><path d="M3 3h7v7H3zM14 3h7v7h-7zM14 14h7v7h-7zM3 14h7v7H3z"/></svg>
            Pipeline
          </button>
          <button className={`nav-item ${tab === 'kpi' ? 'active' : ''}`} onClick={() => setTab('kpi')}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></svg>
            KPI Dashboard
          </button>
        </nav>
        <div className="sidebar-footer">
          <div className="sync-indicator">
            <span className="sync-dot"></span>
            <span>Live sync</span>
          </div>
          <button className="logout-btn" onClick={() => supabase.auth.signOut()}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>
            Sign out
          </button>
        </div>
      </aside>
      <main className="main">
        {tab === 'pipeline' ? <Pipeline /> : <KPIDashboard />}
      </main>
    </div>
  )
}
